import React from 'react';
import Styles from './cardStyle.module.scss';
type Props = {
  title: string;
  children?: React.ReactNode;
};
const CardTitle = ({ title, children }: Props) => {
  return (
    <div className={Styles['title']}>
      {children ? (
        children
      ) : (
        <>
          {title}
          <hr />
        </>
      )}
    </div>
  );
};
export default CardTitle;
